import {IUser, UserModel} from "../../modules/auth";
import {AssociationModel, IAssociationModel} from "./association.model";
import {CountryModel, ICountryModel} from "../general/country.model";
import {IStateModel, StateModel} from "../general/state.model";
import {CityModel, ICityModel} from "../general/city.model";
import * as moment from 'moment';

export interface IPracticeModel{
  id?: number;
  name: string;
  owner_id: number;
  is_enabled: boolean;
  nsi: string;
  association_id: number;
  email: string;
  phone_number: string;
  address: string;
  country_id: number;
  state_id: number;
  city_id: number;
  zip_code: string;
  created: moment.Moment;
  modified: moment.Moment;
  city: string;
  state: string;
  country: string;
  owner?: IUser;
  association?: IAssociationModel;
}


export class PracticeModel {
  id?: number;
  name: string;
  ownerId: number;
  isEnabled: boolean;
  nsi: string;
  associationId: number;
  email: string;
  phoneNumber: string;
  address: string;
  countryId: number;
  stateId: number;
  cityId: number;
  zipCode: string;
  created: moment.Moment;
  modified: moment.Moment;
  city: string;
  state: string;
  country: string;
  owner?: UserModel;
  association?: AssociationModel;

  constructor() {
    this.isEnabled = true;
  }

  static fromObject(practice: IPracticeModel): PracticeModel {
    let obj = new PracticeModel();
    obj.id = practice.id;
    obj.name = practice.name;
    obj.isEnabled = practice.is_enabled;
    obj.associationId = practice.association_id;
    obj.countryId = practice.country_id;
    obj.cityId = practice.city_id;
    obj.ownerId = practice.owner_id;
    obj.email = practice.email;
    obj.nsi = practice.nsi || '-';
    obj.stateId = practice.state_id;
    obj.phoneNumber = practice.phone_number;
    obj.address = practice.address;
    obj.zipCode = practice.zip_code;
    obj.created = moment(practice.created);
    obj.modified = moment(practice.modified);
    obj.country = practice.country || '';
    obj.state = practice.state||'';
    obj.city = practice.city || '';
    obj.owner = (practice.owner) ? UserModel.fromObject(practice.owner):undefined;
    obj.association = (practice.association) ? AssociationModel.fromObject(practice.association) : undefined;
    return obj;
  }

  static fromObjectArray(practices: IPracticeModel[] = []): PracticeModel[] {
    return practices.map(PracticeModel.fromObject);
  }
}


export interface IResultPracticeModel {
  count: number;
  next: string;
  previous: string;
  results: IPracticeModel[];
}
export interface IPracticeIndicatorModel {
  has_gap:boolean;
  has_ra:boolean;
}

export class  PracticeIndicatorModel {
  has_gap:boolean;
  has_ra:boolean;
}

export class ResultPracticeModel {
  count: number = 0;
  next: string;
  previous: string;
  results: PracticeModel[] = [];

  constructor() {
    this.count = 0;
  }

  static fromObject(result: IResultPracticeModel): ResultPracticeModel {
    let obj = new ResultPracticeModel();
    obj.count = result.count | 0;
    obj.next = result.next;
    obj.previous = result.previous;
    obj.results = (result.results && result.results.length > 0) ? PracticeModel.fromObjectArray(result.results) : [];
    return obj;
  }
}

/*Practice Model Nueva Structura*/

export class ItemPracticeModel {
  id?: number;
  name: string;
  value:string | '';
  label:string;
  ownerId: number;
  isEnabled: boolean;
  nsi: string;
  associationId: number;
  email: string;
  phoneNumber: string;
  address: string;
  countryId: number;
  stateId: number;
  cityId: number;
  zipCode: string;
  created: moment.Moment;
  modified: moment.Moment;
  city: string;
  state: string;
  country: string;
  owner?: UserModel;
  association?: AssociationModel;

  constructor() {
    this.isEnabled = true;
  }
  static fromObject(practice: IItemPracticeModel): ItemPracticeModel {
    let obj = new ItemPracticeModel();
    obj.id = practice.id;
    obj.name = practice.label;
    obj.label =practice.name;
    obj.name=practice.name;
    obj.value = practice.nsi ;
    obj.isEnabled = practice.is_enabled;
    obj.associationId = practice.association_id;
    obj.countryId = practice.country_id;
    obj.cityId = practice.city_id;
    obj.email = practice.email;
    obj.nsi = practice.nsi || '-';
    obj.stateId = practice.state_id;
    obj.phoneNumber = practice.phone_number;
    obj.address = practice.address;
    obj.zipCode = practice.zip_code;
    obj.created = moment(practice.created);
    obj.modified = moment(practice.modified);
    obj.country = practice.country || '';
    obj.state = practice.state || '';
    obj.city = practice.city  ||  '';
    obj.association = (practice.association) ? AssociationModel.fromObject(practice.association) : undefined;
    return obj;
  }

  static fromObjectArray(practices: IItemPracticeModel[]): ItemPracticeModel[] {
    return practices.map((practice: IItemPracticeModel) => ItemPracticeModel.fromObject(practice));
  }
}

export interface IItemPracticeModel {
  id?: number ;
  label: string;
  value: string ;
  is_enabled: boolean;
  nsi: string;
  name:string;
  association_id: number;
  email: string;
  phone_number: string;
  address: string;
  country_id: number;
  state_id: number;
  city_id: number;
  zip_code: string;
  created: string;
  modified: string;
  country: string;
  state: string;
  city: string;
  association?: IAssociationModel;
}

export class TinResultModel {
  value:string;
  label:string;
  id?: number;
  items: ItemPracticeModel[];

  constructor() {
    this.items = [];
  }

  static fromObject(tinResult: ITinResultModel): TinResultModel {
    let obj = new TinResultModel();
    const tempId = Number(tinResult.tin);

    if (!isNaN(tempId)) {
      obj.id = tempId;
    } else {
      obj.id = 0;
    }

    obj.value = tinResult.tin;
    obj.label = tinResult.tin;
    obj.items = ItemPracticeModel.fromObjectArray(tinResult.practices);
    return obj;
  }

  static fromObjectArray(tinResults: ITinResultModel[]): TinResultModel[] {
    return tinResults.map((tinResult: ITinResultModel) => TinResultModel.fromObject(tinResult));
  }
}

export interface ITinResultModel {
  tin: string;
  practices: IItemPracticeModel[];
}

export interface IResultItemPracticeModel {
  count: number;
  next: string;
  previous: string;
  results: ITinResultModel[];
}

export class ResultItemPracticeModel {
  count: number = 0;
  next: string;
  previous: string;
  results: TinResultModel[] = [];

  constructor() {
    this.count = 0;
  }

  static fromObject(result: IResultItemPracticeModel): ResultItemPracticeModel {
    let obj = new ResultItemPracticeModel();
    obj.count = result.count | 0;
    obj.next = result.next;
    obj.previous = result.previous;
    obj.results = (result.results && result.results.length > 0) ? TinResultModel.fromObjectArray(result.results) : [];
    return obj;
  }
}

